import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const HideOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function HideOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="m16.39 10.37 6.62-6.62-1.5-1.5-2.46 2.46C17.08 3.16 14.66 2.25 12 2.25c-5.41 0-9.84 3.77-11.5 9 .92 2.91 2.71 5.36 5.04 6.97l-2.03 2.03 1.5 1.5L16.4 10.36l-.01.01ZM6.97 16.8c-1.92-1.21-3.46-3.13-4.36-5.54 1.59-4.27 5.22-7 9.39-7 2.07 0 4.01.67 5.63 1.88l-2.24 2.24c-.82-.96-2.03-1.59-3.4-1.59a4.49 4.49 0 0 0-4.49 4.49c0 1.37.62 2.58 1.59 3.4L6.97 16.8Zm2.53-5.52c0-1.37 1.12-2.49 2.49-2.49.81 0 1.53.4 1.98 1l-3.48 3.48c-.6-.46-1-1.17-1-1.98l.01-.01ZM21.89 7.88l-1.44 1.44c.36.6.67 1.25.93 1.95-1.59 4.27-5.22 7-9.38 7-.16 0-.32-.01-.47-.02l-1.79 1.79c.73.15 1.48.23 2.26.23 5.41 0 9.84-3.77 11.5-9a14.03 14.03 0 0 0-1.61-3.38v-.01Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default HideOutlined;